export const purlinTabs = {
  geometry: {
    tab: 'geometry',
    label: 'Bauteil',
  },
  verticalTransmission: {
    tab: 'vertical-transmission',
    label: 'Vertikale Verbindungen',
  },
}
